/* eslint-disable */
import { UPDATE_USER_PROFILE } from '../UserProfile.types';

/**
 * Action to update the user profile in redux state
 * @param {data} data The data
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, UPDATE_USER_PROFILE>>} The created `Action`
 */
const updateUserProfile = (data) => ({ fromPayload }) => {
  return fromPayload(data.profile, {}, UPDATE_USER_PROFILE);
};

export default updateUserProfile;
